import React, { useEffect } from "react";
import { Route, Switch, useLocation, useHistory } from "react-router-dom";
import { TabNavigation } from "Components/common/TabNavigation";
import BillingOverview from "./BillingOverview";
import BillingHistory from "./BillingHistory";

const tabs = [
  {
    name: "Overview",
    id: "overview",
    path: "overview",
  },
  {
    name: "Billing History",
    id: "billingHistory",
    path: "history",
  },
];

const UserBilling = () => {
  const location = useLocation();
  const history = useHistory();

  useEffect(() => {
    if (location.pathname === "/settings/billing") {
      history.replace("/settings/billing/overview");
    }
  }, [location]);

  return (
    <div className="userBillingPage">
      <TabNavigation tabList={tabs} activeTab="overview" />
      <Switch>
        <Route
          index
          path="/settings/billing/overview"
          component={BillingOverview}
        />
        <Route path="/settings/billing/history" component={BillingHistory} />
      </Switch>
    </div>
  );
};

export default UserBilling;
